import type { FieldKey, RuleDefinition } from '../domain/types';
import { getCellText } from '../domain/cells';
import { getFieldDefinition } from '../domain/fields';
import { isPlaceholderText } from '../utils/text';
import { finding } from './helpers';

const PLACEHOLDER_FIELDS: readonly FieldKey[] = ['name', 'description'];

export const BQ014: RuleDefinition = {
  id: 'BQ014',
  name: '疑似占位描述',
  description: '提醒“待定”“TBD”“同上”“暂估”或横线等疑似占位内容。',
  defaultSeverity: 'warning',
  enabled: true,
  applicableFields: PLACEHOLDER_FIELDS,
  message: '文本疑似为占位内容，需要人工确认。',
  suggestion: '请核对并补充正式描述；“暂估”仅作复核提醒，不代表数据错误。',
  check: ({ detailRows }) =>
    detailRows.flatMap((row) =>
      PLACEHOLDER_FIELDS.flatMap((field) => {
        const text = getCellText(row, field);
        if (!isPlaceholderText(text)) return [];
        return [
          finding(row, field, {
            currentValue: text,
            message: `${getFieldDefinition(field).label}“${text}”疑似为占位内容，请人工确认。`,
          }),
        ];
      }),
    ),
};
